export default "__VITE_ASSET__da231d37__"